import React, { useEffect, useState } from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DatePicker from "components/DatePicker";
import "./style.css";
import { useDispatch } from "react-redux";
import { login, LoginData } from "Redux/Login/newLogin.actions";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    // '@media(min-width: 960px)': {
    //   display: 'flex',
    //   justifyContent: 'center',
    //   height: '100vh',
    //   width: '100%',
    // },
  },
  header: {
    minHeight: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid #e0e0e0",
  },
  header__bar: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    height: "100%",
    width: "90%",
  },
  logo: {
    width: "180px",
  },
  containerWrapper: {
    display: "flex",
    justifyContent: "center",
    "@media(max-width: 200px)": {
      display: "block",
      height: "fit-content",
    },
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "2rem",
    "@media(min-width: 760px)": {
      height: "75%",
      width: "400px",
    },
  },
  name: {
    display: "flex",
    justifyContent: "start",
    textAlign: "start",
    margin: "4rem 0 1rem",
    color: "#14A6A6",
    fontWeight: "500",
    fontSize: "36px",
    "@media(min-width: 760px)": {
      justifyContent: "center",
      textAlign: "center",
    },
  },
  subHeading: {
    margin: "0 0 3rem",
    color: "#4F566B",
    fontSize: "22px",
    fontWeight: "400",
    lineHeight: "24px",
    "@media(min-width: 760px)": {
      justifyContent: "center",
      textAlign: "center",
    },
  },
  clinicName: {
    fontWeight: "600",
  },
  dob: {
    margin: "0 0 1rem",
  },
  confirmBtn: {
    margin: "4rem 0 1rem",
    width: "100%",
    color: "white !important",
  },
  copyright: {
    padding: "1rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
  },
}));

function Login() {
  const classes = useStyles();
  let a = window.location.href.split("/").pop();
  const [patientName, setPatientName] = useState("");
  const [clinicName, setClinicName] = useState("");
  const [dob, setDob] = useState(null);
  const [dobError, setDobError] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const dispatch = useDispatch();
  const { loginResponse, getLoginData } = useSelector((state) => state.login);
  const formatDate = (date) => {
    if (date === null) {
      return null;
    }
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) {
      month = "0" + month;
    }
    if (day.length < 2) {
      day = "0" + day;
    }
    if (isNaN(year)) {
      return null;
    } else {
      return [year, month, day].join("-");
    }
  };

  function handledate(e) {
    setDob(e);
    setDobError(false);
    setErrMessage("");
  }

  const handleConfirm = () => {
    if (dob) {
      dispatch(
        login({
          dob: formatDate(dob),
          pin: a.toString(),
        })
      );
    } else {
      setDobError(true);
      setErrMessage("Please enter valid DOB");
    }
  };

  useEffect(() => {
    localStorage.clear();
    dispatch(LoginData(a.toString()));
    localStorage.setItem("pin", a.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (getLoginData && getLoginData?.data) {
      if (getLoginData?.responseCode === 0) {
        let data = getLoginData.data;
        setPatientName(data.patientName);
        setClinicName(data.clinicName);
        localStorage.setItem("apmtTypeId", data.appointmentTypeId);
        localStorage.setItem("checkin", data.checkInEnabled);
        localStorage.setItem("showEstimate", data.estimateEnabled);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getLoginData?.data]);

  useEffect(() => {
    if (loginResponse && loginResponse.data) {
      if (loginResponse.responseCode === 0) {
        let data = loginResponse.data;
        localStorage.setItem("accessToken", data.accessToken);
        window.location.href = "/details";
      }
    }else if (loginResponse && loginResponse.responseCode === 125) {
      setDobError(true);
      setErrMessage("Login Failed. Invalid Credentials. Please try again.");
    }else if(loginResponse && loginResponse.responseCode === 117){
      setDobError(true);
      setErrMessage("Login Failed. Please try again.");         
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginResponse,loginResponse.data]);

  return (
    <div className={classes.root}>
      <div className={classes.containerWrapper}>
        <Grid container className={classes.container}>
          <Grid xs={12} sm={12} item>
            <Typography className={classes.name}>{patientName}</Typography>
          </Grid>
          <Grid xs={12} sm={12} item>
            <p className={classes.subHeading}>
              Confirm your date of birth to check-in for your appointment with{" "}
              <span className={classes.clinicName}>{clinicName}</span>
            </p>
          </Grid>

          <Grid xs={12} sm={12} item>
            <div className="dob_label">Date of birth</div>
          </Grid>

          <Grid xs={12} sm={12} item>
            <div className="dob_textbox">
              <DatePicker
                // required
                value={dob}
                // label="Date of birth"
                // variant="outlined"
                variant="standard"
                onChange={handledate}
                maxDate={new Date()}
                error={dobError}
                helperText={errMessage}
              />
            </div>
          </Grid>
          <Grid xs={12} sm={12} item>
            <Button
              className={classes.confirmBtn}
              variant="contained"
              color="primary"
              size="large"
              onClick={handleConfirm}
            >
              Authenticate
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default Login;
